if (!customElements.get('kf-mobile-card-gallery')) {
  customElements.define(
    'kf-mobile-card-gallery',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        let startX = 0;
        let startY = 0;
        let moved = false;
        let suppressUntil = 0;

        this.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1) return;

            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            moved = false;
            event.stopPropagation();
          },
          { passive: true }
        );

        this.addEventListener(
          'touchmove',
          (event) => {
            if (event.touches.length !== 1) return;

            const dx = event.touches[0].clientX - startX;
            const dy = event.touches[0].clientY - startY;

            if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
              moved = true;
            }

            event.stopPropagation();
          },
          { passive: true }
        );

        this.addEventListener(
          'touchend',
          (event) => {
            if (moved) suppressUntil = Date.now() + 500;
            event.stopPropagation();
          },
          { passive: true }
        );

        this.addEventListener(
          'touchcancel',
          () => {
            moved = false;
            suppressUntil = Date.now() + 500;
          },
          { passive: true }
        );

        this.addEventListener(
          'click',
          (event) => {
            if (Date.now() < suppressUntil) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          },
          true
        );
      }
    }
  );
}
